import { createContext, useContext, useLayoutEffect } from 'react'

/**
 * Lets routed content drop `main`'s own gutter: the settings well sits in the main area with
 * its own margin, so main's padding would double it. The shell provides the setter.
 */
export const MainGutterContext = createContext<(stripped: boolean) => void>(() => undefined)

/** Layout effect, so the gutter changes before paint and never flashes. */
export function useStripMainGutter(stripped: boolean): void {
  const setStripped = useContext(MainGutterContext)
  useLayoutEffect(() => {
    setStripped(stripped)
    return () => setStripped(false)
  }, [stripped, setStripped])
}
